import { useContext, useEffect } from 'react';
import { ContextOperacion, ContextOperacionType } from "../../RefactorLayout";
import { useLoader } from "../../../../hooks/useLoader";
import { QueryStatus } from "../../../../types";
import { Alert, Grid } from "@mui/material";
import { OperacionAFOPU } from "./types/types";
import { SeccionFirmas } from "../../components/SeccionFirmas";
import { SistemaTipo } from "../../../../types/enum/enum";
import SeccionAFOPUDatosOperacion from './components/SeccionAFOPUDatosOperacion';
import { useOperacionAFOPU } from './hooks/useOperacionAFOPU';
import SeccionAFOPUTablaValores from './components/SeccionAFOPUTablaValores';
import { OperacionAFOPUFields } from './types/fields';


interface SistemaAFOPUContentProps {
  operacion: OperacionAFOPU
}

const SistemaAFOPUContent = ({ operacion }: SistemaAFOPUContentProps) => {
  return (
    <>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <SeccionAFOPUDatosOperacion
            operacion={operacion}
          />
        </Grid>

        <Grid item xs={12}>
          <SeccionAFOPUTablaValores operacion={operacion} codSistemaPrincipal={operacion[OperacionAFOPUFields.CodPais]}/>
        </Grid>

        <Grid item xs={12}>
          <SeccionFirmas
            codSistema={SistemaTipo.AFOPU}
            idOperacion={operacion.id}
          />
        </Grid>
      </Grid>
    </>
  )
}

function SistemaAFOPU() {
  const { idOperacion } = useContext<ContextOperacionType>(ContextOperacion);
  const { status, operacion } = useOperacionAFOPU(idOperacion);
  const { showLoader, hideLoader } = useLoader();

  useEffect(() => {
    if (status === QueryStatus.Loading) {
      showLoader()
    } else {
      hideLoader();
    }
  }, [status]);

  if (!operacion) {
    return null;
  }

  if (status === QueryStatus.Error) {
    return (
      <Alert severity='error'>
        Se produjo un error al cargar la operación.
      </Alert>
    )
  }

  return (
    <SistemaAFOPUContent
      operacion={operacion}
    />
  )
}

export default SistemaAFOPU;